// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_be-2";
export var aiChatCartContainerExit = "_be-4";
export var aiChatContainerLarge = "_be-0";
export var aiChatContainerSmall = "_be-1";
export var aiChatIcon = "_be-6";
export var slideInFromRight = "_be-3";
export var slideOutToRight = "_be-5";